/*
* <license header>
*/

import React from 'react'
import { Flex, Heading, Text, View } from '@adobe/react-spectrum'

const ASSISTANT_GRADIENT = 'linear-gradient(90deg, #e85d4c 0%, #c77eb5 100%)'

export const PageHeaderBanner = ({ title, subtitle }) => {

  return (
    <View
      marginBottom="size-500"
      padding="size-600"
      UNSAFE_style={{
        background: ASSISTANT_GRADIENT,
        borderRadius: '16px',
        minHeight: '12rem'
      }}
    >
      <Flex direction="column" alignItems="center" gap="size-200">
        <Heading level={1} UNSAFE_style={{ margin: 0, color: 'white', fontSize: '2rem', fontWeight: 700 }}>
          {title}
        </Heading>
        {subtitle && (
          <Text UNSAFE_style={{ color: 'rgba(255,255,255,0.95)', fontSize: '1rem', textAlign: 'center', lineHeight: 1.5 }}>
            {subtitle}
          </Text>
        )}
      </Flex>
    </View>
  )
}
